/**
 * UI-17: Pure severity derivation function
 *
 * Deterministic: same input → same output, always.
 * Used by StaffLayout to drive sidebar attention signals.
 */

import type { PulseStatus, AlertSeverity } from '../services/controlTowerTypes';

export type SystemSeverity = 'normal' | 'warning' | 'critical';

export interface SeverityInput {
  pulseStatus: PulseStatus;
  alerts: ReadonlyArray<{ severity: AlertSeverity }>;
  riskCount: number;
}

export function deriveSystemSeverity(input: SeverityInput): SystemSeverity {
  const { pulseStatus, alerts, riskCount } = input;
  const criticalAlerts = alerts.filter(a => a.severity === 'critical').length;

  // Critical: pulse critical, 2+ critical alerts, or 3+ guest risks
  if (pulseStatus === 'critical' || criticalAlerts >= 2 || riskCount >= 3) {
    return 'critical';
  }

  // Warning: pulse warning, any critical alert, any warning alert, or any risk
  if (
    pulseStatus === 'warning' ||
    criticalAlerts >= 1 ||
    alerts.some(a => a.severity === 'warning') ||
    riskCount >= 1
  ) {
    return 'warning';
  }

  return 'normal';
}
